module.exports = __webpack_public_path__ + "img/education1.83de2067.jpeg";